<template>
    <div v-if="showPopup" ref="popupAnotacao" data-compType="popupAnotacao" class="popup-anotacao"
        :style="{ '--left-position': currentLeft + 'px', '--top-position': currentTop + 'px' }">
        <div class="header">
            <section class="header__content">
                <span class="header__drag-handle" :class="{ 'is-dragging': drag.isActive }" title="Mover"
                    @mousedown.prevent="startDrag">
                    <DragHandleIconSvg />
                </span>
                <h5 class="title">
                    <slot name="title"></slot>
                </h5>
            </section>
            <span class="header__close" @click="closePopup">
                <CloseSvgIcon />
            </span>
        </div>
        <div class="content">

            <slot name="content"></slot>

            <flatCard class="preview-relatorio">
                <report-line-text :text="previewRelatorioText" />
            </flatCard>
        </div>
        <div class="footer">
            <secondaryButton class="button--cancel" variant="outline" @click="onCancel">Cancelar</secondaryButton>
            <secondaryButton class="button--save" variant="solid" @click="onSave">Salvar</secondaryButton>
        </div>
    </div>
</template>

<script>
import { evtBus } from '@/main';

import CloseSvgIcon from '@/assets/icons/close.svg';
import DragHandleIconSvg from '@/assets/icons/drag-handle.svg';
import SecondaryButton from '@/components/ui/button/secondaryButton.vue';
import FlatCard from '@/components/ui/card/flatCard.vue';
import reportLineText from '@/features/report/components/text/reportLineText.vue';


export default {
    name: 'popupAnotacaoWrapper',
    components: {
        CloseSvgIcon,
        DragHandleIconSvg,
        SecondaryButton,
        FlatCard,
        reportLineText,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        leftPosition: {
            type: Number,
            default: 0,
        },
        topPosition: {
            type: Number,
            default: 0,
        },
        previewRelatorioText: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            showPopup: this.show,
            drag: {
                offsetX: 0,
                offsetY: 0,
                startX: 0,
                startY: 0,
                startOffsetX: 0,
                startOffsetY: 0,
                isActive: false,
            }
        }
    },

    computed: {
        currentLeft() {
            return this.leftPosition + this.drag.offsetX;
        },
        currentTop() {
            return this.topPosition + this.drag.offsetY;
        },
    },

    watch: {
        show: {
            handler(newVal) {
                this.showPopup = newVal;
                if (newVal) {
                    this.drag.offsetX = 0;
                    this.drag.offsetY = 0;
                    this.$nextTick(() => {
                        document.addEventListener('mousedown', this.onClickOutside);
                    });
                } else {
                    document.removeEventListener('mousedown', this.onClickOutside);
                }
            },
            immediate: true
        }
    },

    methods: {

        startDrag(event) {
            this.drag.isActive = true;
            this.drag.startX = event.clientX;
            this.drag.startY = event.clientY;
            this.drag.startOffsetX = this.drag.offsetX;
            this.drag.startOffsetY = this.drag.offsetY;

            document.addEventListener('mousemove', this.onDragMove);
            document.addEventListener('mouseup', this.stopDrag);
        },

        onDragMove(event) {
            if (!this.drag.isActive) return;
            this.drag.offsetX = this.drag.startOffsetX + (event.clientX - this.drag.startX);
            this.drag.offsetY = this.drag.startOffsetY + (event.clientY - this.drag.startY);
        },

        stopDrag() {
            this.drag.isActive = false;
            document.removeEventListener('mousemove', this.onDragMove);
            document.removeEventListener('mouseup', this.stopDrag);
        },

        onClickOutside(event) {
            const popup = this.$refs.popupAnotacao;
            if (popup && !popup.contains(event.target)) {
                this.closePopup();
            }
        },

        closePopup() {
            this.showPopup = false;
            this.$emit('onClose');
        },

        onCancel() {
            this.$emit('onClose');
        },

        onSave() {
            this.$emit('onSave');
        },

    },

    mounted() {

    },

    beforeDestroy() {
        document.removeEventListener('mousemove', this.onDragMove);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('mousedown', this.onClickOutside);
    }
}
</script>

<style scoped>
.popup-anotacao {
    position: fixed;
    top: var(--top-position, 0px);
    left: var(--left-position, 0px);
    z-index: 1000;
    background: white;
    border: 1px solid var(--border-primary);
    border-radius: var(--card-border-radius);
    box-shadow: var(--card-box-shadow);
    /* width: 550px; */
    overflow: hidden;
    margin-top: var(--spacing-xs);
    animation: fadeIn 0.3s ease-in-out;
}

.popup-anotacao>.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-md);
    padding: var(--spacing-md);
    text-align: left;
    background-color: var(--background-gray);
    border-bottom: 1px solid var(--border-primary);
}

.popup-anotacao .header__content {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--spacing-sm);
}

.popup-anotacao .header__drag-handle {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-dark-gray);
    cursor: grab;
    touch-action: none;
    user-select: none;
    transition: color 0.2s ease, scale 0.2s ease;
}

.popup-anotacao .header__drag-handle:hover {
    color: var(--color-primary);
    scale: 1.15;
}

.popup-anotacao .header__drag-handle:active,
.popup-anotacao .header__drag-handle.is-dragging {
    cursor: grabbing;
    color: var(--color-primary);
}

.popup-anotacao .header__drag-handle>svg {
    width: 16px;
    height: 16px;
    pointer-events: none;
}

.popup-anotacao .header__content .title {
    margin: 0;
    font-size: var(--text-md);
    line-height: 1;
    font-weight: 700;
    color: var(--color-primary);
}

.popup-anotacao .header__close {
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: flex-start;
    padding: var(--spacing-xs);
    color: var(--color-dark-gray);
    border: 1px solid var(--border-primary);
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: all 0.2s ease;
}

.popup-anotacao .header__close:hover {
    background-color: var(--background-light-gray);
}

.popup-anotacao .header__close:active {
    scale: 0.98;
}

.popup-anotacao .header__close>svg {
    width: 15px;
    height: 15px;
}

.popup-anotacao>.content {
    width: 100%;
    max-width: 550px;
    min-height: 170px;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
    padding: var(--spacing-md);
    box-sizing: border-box;
}

.popup-anotacao .preview-relatorio {
    flex: 1;
    width: 100%;
}

.popup-anotacao>.footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: var(--spacing-sm);
    padding: var(--spacing-md);
    background-color: var(--background-gray);
    border-top: 1px solid var(--border-primary);
}

.popup-anotacao > .footer .button--cancel,
.popup-anotacao > .footer .button--save {
    min-width: 100px;
    text-align: center;
    justify-content: center;
}

.popup-anotacao > .footer .button--save {
    min-width: 100px;
}

</style>
